import { GradienCheckCircleIcon, GradienWarningIcon, GradienCancelIcon } from "../component/icons/icon-gradient";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';
import LaunchIcon from '@mui/icons-material/Launch';

export const SettingList = [
    { name: 'edit', display_name: 'Edit data source', icon: <LaunchIcon sx={{ fontSize: '18px' }} />, color: 'linear-gradient(to right bottom, #3dbb89, #1b787a)' },
    { name: 'delete', display_name: 'Delete data source', icon: <DeleteIcon sx={{ fontSize: '18px' }} />, color: 'linear-gradient(to right bottom, #ef5350, #d32f2f)' },
];

export const servers = [
    // { name: 'api', display_name: 'API', total: 100, unit: 'APIs' },
    // { name: 'sat', display_name: 'SAT', total: 100, unit: 'Accounts' },
    // { name: 'database', display_name: 'Database', total: 100, unit: 'Database' },
    // { name: 'iot', display_name: 'IoT', total: 100, unit: 'Devices' },
    // { name: 'huawei', display_name: 'Huawei', total: 100, unit: 'Devices' },
    // { name: 'google_drive', display_name: 'Google drive', total: 100, unit: 'Folders' },
    { name: 'onedrive', display_name: 'OneDrive', total: 100, unit: 'Folders' },
];

export const title_transition = [
    { name: 'success', type: 'Electric bill', display_name: 'Electricity bill' },
    { name: 'success', type: 'Water bill', display_name: 'Water bill' },
    { name: 'success', type: 'Fuel Bill', display_name: 'Fuel bill' },
    { name: 'success', type: 'Fuel bill', display_name: 'Fuel bill' },
    { name: 'success', type: 'water_meter', display_name: 'Water meter' },
    { name: 'success', type: 'Travelling bill', display_name: 'Travelling bill' },
    { name: 'success', type: 'xlsx_csv_waste', display_name: 'Waste' },
    { name: 'failed', display_name: 'Failed' },
]

export const overview_status = [
    { display_name: 'Online', total: 26, status: 'success', icon: <GradienCheckCircleIcon color="success" /> },
    { display_name: 'Warning', total: 1, status: 'warning', icon: <GradienWarningIcon color="warning" /> },
    { display_name: 'Error', total: 26, status: 'error', icon: <GradienCancelIcon color="error" /> },
];

export const status = [
    { id: 1, label: 'All', icon: null, color: 'default' },
    { id: 2, label: 'Online', icon: <CheckCircleIcon />, color: 'success' },
    { id: 3, label: 'Offline', icon: <CancelIcon />, color: 'default' },
    { id: 4, label: 'Warning', icon: <WarningIcon />, color: 'warning' },
    { id: 5, label: 'Error', icon: <CancelIcon />, color: 'error' },
];

export const rows = [
    {
        server_name: 'api',
        device: [
            { id: 'DS-0001', lastName: "Snow", name: "Jon", location: "Winterfell", lat_long: "54.2361, -1.4065", status: "Online" },
            { id: 'DS-0002', lastName: "Lannister", name: "Cersei", location: "King's Landing", lat_long: "51.5099, -0.1181", status: "Warning" },
            { id: 'DS-0003', lastName: "Lannister", name: "Jaime", location: "Casterly Rock", lat_long: "53.4817, -2.2426", status: "Error" },
            { id: 'DS-0004', lastName: "Stark", name: "Arya", location: "Braavos", lat_long: "37.9838, 23.7275", status: "Warning" },
            { id: 'DS-0005', lastName: "Targaryen", name: "Daenerys", location: "Dragonstone", lat_long: "50.0657, -5.7164", status: "Offline" },
            { id: 'DS-0006', lastName: "Melisandre", name: "Melisandre", location: "Asshai", lat_long: "35.6895, 139.6917", status: "Online" },
            { id: 'DS-0007', lastName: "Clifford", name: "Ferrara", location: "Volantis", lat_long: "37.7749, -122.4194", status: "Error" },
            { id: 'DS-0008', lastName: "Frances", name: "Rossini", location: "Pentos", lat_long: "40.7128, -74.0060", status: "Offline" },
            { id: 'DS-0009', lastName: "Roxie", name: "Harvey", location: "Meereen", lat_long: "30.0444, 31.2357", status: "Online" },
            { id: 'DS-0010', lastName: "Mormont", name: "Jorah", location: "Bear Island", lat_long: "57.4778, -4.2247", status: "Warning" }
        ]
    },
    {
        server_name: 'huwei',
        device: [
            { id: 'DS-0002', lastName: "Lannister", name: "Cersei", location: "King's Landing", lat_long: "51.5099, -0.1181", status: "Warning" },
            { id: 'DS-0003', lastName: "Lannister", name: "Jaime", location: "Casterly Rock", lat_long: "53.4817, -2.2426", status: "Error" },
            { id: 'DS-0004', lastName: "Stark", name: "Arya", location: "Braavos", lat_long: "37.9838, 23.7275", status: "Warning" },
            { id: 'DS-0005', lastName: "Targaryen", name: "Daenerys", location: "Dragonstone", lat_long: "50.0657, -5.7164", status: "Offline" },
            { id: 'DS-0006', lastName: "Melisandre", name: "Melisandre", location: "Asshai", lat_long: "35.6895, 139.6917", status: "Online" },
            { id: 'DS-0007', lastName: "Clifford", name: "Ferrara", location: "Volantis", lat_long: "37.7749, -122.4194", status: "Error" },
            { id: 'DS-0008', lastName: "Frances", name: "Rossini", location: "Pentos", lat_long: "40.7128, -74.0060", status: "Offline" },
            { id: 'DS-0009', lastName: "Roxie", name: "Harvey", location: "Meereen", lat_long: "30.0444, 31.2357", status: "Online" },
            { id: 'DS-0010', lastName: "Mormont", name: "Jorah", location: "Bear Island", lat_long: "57.4778, -4.2247", status: "Warning" }
        ]
    },
    {
        server_name: 'iot',
        device: [
            { id: 'DS-0001', lastName: "Snow", name: "Jon", location: "Winterfell", lat_long: "54.2361, -1.4065", status: "Online" },
            { id: 'DS-0002', lastName: "Lannister", name: "Cersei", location: "King's Landing", lat_long: "51.5099, -0.1181", status: "Warning" },
            { id: 'DS-0003', lastName: "Lannister", name: "Jaime", location: "Casterly Rock", lat_long: "53.4817, -2.2426", status: "Error" },
            { id: 'DS-0004', lastName: "Stark", name: "Arya", location: "Braavos", lat_long: "37.9838, 23.7275", status: "Warning" },
            { id: 'DS-0005', lastName: "Targaryen", name: "Daenerys", location: "Dragonstone", lat_long: "50.0657, -5.7164", status: "Offline" },
            { id: 'DS-0006', lastName: "Melisandre", name: "Melisandre", location: "Asshai", lat_long: "35.6895, 139.6917", status: "Online" },
            { id: 'DS-0007', lastName: "Clifford", name: "Ferrara", location: "Volantis", lat_long: "37.7749, -122.4194", status: "Error" },
            { id: 'DS-0008', lastName: "Frances", name: "Rossini", location: "Pentos", lat_long: "40.7128, -74.0060", status: "Offline" },
            { id: 'DS-0009', lastName: "Roxie", name: "Harvey", location: "Meereen", lat_long: "30.0444, 31.2357", status: "Online" },
            { id: 'DS-0010', lastName: "Mormont", name: "Jorah", location: "Bear Island", lat_long: "57.4778, -4.2247", status: "Warning" }
        ]
    },
    {
        server_name: 'onedrive',
        device: [
            { last_modified: '2024-01', id: 'DS-0001', name: "Jon", no: 74, success_files: 30, status: "Online" },
            { last_modified: '2024-01', id: 'DS-0002', name: "Cersei", no: 74, success_files: 30, status: "Warning" },
            // { last_modified: '2024-01', id: 'DS-0003', name: "Jaime", no: 74, success_files: 30, status: "Error" },
            // { last_modified: '2024-01', id: 'DS-0004', name: "Arya", no: 74, success_files: 30, status: "Warning" },
            // { last_modified: '2024-01', id: 'DS-0005', name: "Daenerys", no: 74, success_files: 30, status: "Offline" },
            // { last_modified: '2024-01', id: 'DS-0006', name: "Melisandre", no: 74, success_files: 30, status: "Online" },
            // { last_modified: '2024-01', id: 'DS-0007', name: "Ferrara", no: 74, success_files: 30, status: "Error" },
            // { last_modified: '2024-01', id: 'DS-0008', name: "Rossini", no: 74, success_files: 30, status: "Offline" },
            // { last_modified: '2024-01', id: 'DS-0009', name: "Harvey", no: 74, success_files: 30, status: "Online" },
            // { last_modified: '2024-01', id: 'DS-0010', name: "Jorah", no: 74, success_files: 30, status: "Warning" }
        ]
    }
];

// Sample JSON data
export const folder_data = [
    {
        name: "Main Folder",
        id: "folder-id-1",
        children: [
            {
                name: "Sub Folder 1",
                id: "folder-id-2",
                children: [
                    {
                        name: "Sub Sub Folder 1",
                        id: "folder-id-3",
                        children: [
                            { name: "Sub Sub Sub Folder 1", id: "folder-id-4", children: [] },
                        ],
                    },
                    { name: "Sub Sub Folder 2", id: "folder-id-5", children: [] },
                ],
            },
            { name: "Sub Folder 2", id: "folder-id-6", children: [] },
        ],
    }
];

export const building_list = [
    { id: '1', name: 'อาคารเรือนไม้' },
];

export const input_type_list = [
    { id: '1', name: 'Electricity' },
    { id: '2', name: 'Water' },
];

export const configure = [
    {
        "id": 10,
        "status": "CREATED",
        "building": {
            "id": 4,
            "display": "ตึก TTC"
        },
        "input_type": {
            "id": 1,
            "display": "Electricity"
        },
        "directory": {
            "id": 22,
            "display": "test4"
        }
    },
    {
        "id": 8,
        "status": "UPDATED",
        "building": {
            "id": 4,
            "display": "ตึก TTC"
        },
        "input_type": {
            "id": 1,
            "display": "Electricity"
        },
        "directory": {
            "id": 1111,
            "display": "CCCCC"
        }
    },
    {
        "id": 6,
        "status": "DUPLICATE",
        "building": {
            "id": 4,
            "display": "ตึก TTC"
        },
        "input_type": {
            "id": 1,
            "display": "Electricity"
        },
        "directory": {
            "id": 12,
            "display": "test1"
        }
    },
    {
        "id": 1,
        "status": "NOT_FOUND",
        "building": {
            "id": 4,
            "display": "ตึก TTC"
        },
        "input_type": {
            "id": 1,
            "display": "Electricity"
        },
        "directory": {
            "id": 1223,
            "display": "test22"
        }
    }
]